import { WidgetBlockName } from 'api/types/widgets';

import { WIDGET_BLOCK_NAME_TO_SECTION_TYPE_CODE } from './consts';

export const getWidgetVisibilitySettingsTypeCodes = (blockName: WidgetBlockName): string[] => {
  return WIDGET_BLOCK_NAME_TO_SECTION_TYPE_CODE[blockName].split('.');
};
